import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { TabView, TabPanel } from 'primereact/tabview';
import ExcelUploader from "./ExcelUploader";
import CargarSlider from "../cargarSlider/CargarSlider";
import CargarNoticia from "../cargarNoticias/CargarNoticia";
import EditarNoticias from "../cargarNoticias/EditarNoticias";

function Administracion() {
    const auth = useAuth();
    const userRole = auth.role || null;
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className="">
            <center>
                <h1 className="botonbordeazul text-white px-5 mx-5 py-3 h1">
                    Panel de Control
                </h1>
            </center>

            {userRole === "admin" && (
                <div
                    id="panel"
                    style={{
                        border: '1px solid #000',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        padding: '10px',
                        borderRadius: '5px'
                    }}
                >
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="Cargar Slider">
                            <CargarSlider />
                        </TabPanel>
                        <TabPanel header="Cargar Noticia">
                            <CargarNoticia />
                        </TabPanel>
                        <TabPanel header="Editar Noticias">
                            <EditarNoticias />
                        </TabPanel>
                        <TabPanel header="Cargar Empleados">
                            <ExcelUploader />
                        </TabPanel>
                    </TabView>
                </div>
            )}

            <div>

            </div>

        </div>
    );
}

export default Administracion;
